import { createFileRoute, redirect } from "@tanstack/react-router";

// /explore duplicated /categories. Kept as a permanent redirect so old links,
// shares and search results still land somewhere meaningful.
export const Route = createFileRoute("/explore")({
  beforeLoad: () => {
    throw redirect({ to: "/categories", replace: true, statusCode: 301 });
  },
  head: () => ({
    meta: [
      { title: "Explore Smartasaurus - Browse every series" },
      { name: "description", content: "Browse every Smartasaurus series: weird animals, deep ocean, the human body, space, dangerous nature and unexplained mysteries." },
      { property: "og:title", content: "Explore Smartasaurus" },
      { property: "og:description", content: "Browse every Smartasaurus series and pick your next discovery." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Explore Smartasaurus" },
      { name: "twitter:description", content: "Browse every Smartasaurus series and pick your next discovery." },
    ],
    links: [{ rel: "canonical", href: "https://smartasaurus.com/categories" }],
  }),
  component: () => null,
});
